import React, { Fragment } from "react";

import SearchProperties from "../../../common/SearchProperties";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme4Styles from "../scss/theme4.module.scss";

class PropertySearch extends SearchProperties {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      propertyCategories,
      propertyTypes,
      locale,
      defaultLocale,
    } = this.props;

    let placeholder = translateStatic("city", locale, defaultLocale);
    placeholder += ", " + translateStatic("address", locale, defaultLocale);
    placeholder += ", " + translateStatic("zip_code", locale, defaultLocale);

    return (
      <Fragment>
        <div className={`${theme4Styles.searchColm}`}>
          <div className={`${theme4Styles.filterSearch}`}>
            <input
              type="text"
              className={theme4Styles.field}
              placeholder={placeholder}
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme4Styles.srch}
              onClick={() => this.searchProperties()}
            ></button>
          </div>
        </div>
        <div className={`${theme4Styles.filterC}`}>
          <div className={`${theme4Styles.filterRow}`}>
            <div className={theme4Styles.colm}>
              <select
                className={theme4Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
            <div className={theme4Styles.colm}>
              <select
                className={theme4Styles.field}
                name="category"
                value={this.state.searchForm.category}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("category", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyCategories.map((category) => {
                    return (
                      <option value={category.id} key={category.id}>
                        {getTranslatedValue(
                          category.translations,
                          "name",
                          locale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
            <div className={theme4Styles.colm}>
              <select
                className={theme4Styles.field}
                name="bedrooms"
                value={this.state.searchForm.bedrooms}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("bedroom", locale, defaultLocale)}
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4+</option>
              </select>
            </div>
            <div className={theme4Styles.colm}>
              <select
                className={theme4Styles.field}
                name="bathrooms"
                value={this.state.searchForm.bathrooms}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("bathroom", locale, defaultLocale)}
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4+</option>
              </select>
            </div>
          </div>
          <div className={`${theme4Styles.filterBtns}`}>
            <button
              className={`${theme4Styles.btn} ${theme4Styles.btnSm} ${theme4Styles.btnPrimary}`}
              onClick={() => this.searchProperties()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme4Styles.btn} ${theme4Styles.btnSm} ${theme4Styles.btnDark}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PropertySearch;
